import React from 'react';
import younger from '../../images/younger.svg';
import older from '../../images/older.svg';

const AgeLevelNavigation = ({ ageLevel, setAgeLevel, clickHandler }) => {
	return (
		<nav className='age-level'>
			<ul>
				<li className={`younger ${ ageLevel === 'younger' ? 'active' : '' }`}>
					<img
						src={younger}
						onClick={() => setAgeLevel('younger')}
						alt="younger age group"
						title="Younger"
					/>
				</li>
				<li className={`older ${ ageLevel === 'older' ? 'active' : '' }`}>
					<img
						src={older}
						onClick={() => setAgeLevel('older')}
						alt="older age group"
						title="Older"
					/>
				</li>
			</ul>
			<div className='close' onClick={clickHandler}></div>
		</nav>
	);
};

export default AgeLevelNavigation;